import SearchDesktop from './SearchDesktop';

export default SearchDesktop;
